module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.collapsed) ? _c('h1', [_vm._v("互见总后台")]) : _vm._e()])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-s-fold"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": "",
      "collapse": _vm.collapsed
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_vm._l((_vm.$router.options.routes), function(item, index) {
    return [(
      !item.leaf && (item.path == '/' || _vm.menusPath.includes(item.path))
    ) ? _c('el-submenu', {
      key: index,
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((item.children), function(child) {
      return [(child.children) ? [_c('el-submenu', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_c('template', {
        slot: "title"
      }, [_c('i', {
        class: child.iconCls
      }), _c('span', [_vm._v(_vm._s(child.name))])]), _vm._v(" "), _vm._l((child.children), function(v) {
        return [_c('el-menu-item', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!v.hidden),
            expression: "!v.hidden"
          }],
          key: v.path,
          attrs: {
            "index": v.path
          }
        }, [_vm._v(_vm._s(v.name) + "\n                  ")])]
      })], 2)] : [_c('el-menu-item', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!child.hidden),
          expression: "!child.hidden"
        }],
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n              ")])]]
    })], 2) : _vm._e(), _vm._v(" "), (
      item.leaf &&
      item.children.length > 0 &&
      _vm.menusPath.includes(item.children[0].path)
    ) ? _c('el-menu-item', {
      key: index,
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _c('span', [_vm._v(_vm._s(item.children[0].name))])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e8749c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 207
// module chunks = 28